import { startLoading, endLoading } from '@/api'

import pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'

// Styles
var styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [ 0, 0, 0, 10 ]
  },
  small: {
    fontSize: 10
  },
  medium: {
    fontSize: 12
  },
  orange: {
    color: '#f48120'
  },
  orangeTitleLarge: {
    fontSize: 14,
    color: '#f48120',
    bold: true
  }
}

/**
* Download Report
* @param {Object} survey - Survey
*/
export async function downloadReport ({ dispatch, state }, survey) {
  let loaderName = 'downloadReport'
  startLoading(dispatch, loaderName)

  /*
   * In order to make the loading state work properly,
   * we need to wrap the pdfMake logic inside a setTimeout(fn, 0)
   * which acts like nextTick. If we don't do this, the loading state takes time to update.
   */
  setTimeout(function () {
    pdfMake.vfs = pdfFonts.pdfMake.vfs

    // Footer
    var footer = (currentPage, pageCount) => {
      return {
        columns: [
          { image: document.getElementsByClassName('logo')[0].src, fit: [50, 50] },
          { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'small', margin: [ 0, 6, 0, 0 ] }
        ],
        margin: [ 40, 0 ]
      }
    }
    // Content
    var content = []

    // Top survey details
    var topSurveyDetails = {
      columns: [
        {
          columns: [
            {
              type: 'none',
              style: 'small',
              ul: [
                { text: 'Location', bold: true },
                { text: state.surveyDetails.location, margin: [ 0, 0, 0, 5 ] },
                { text: 'Account Number', bold: true },
                { text: state.surveyDetails.accountNumber, margin: [ 0, 0, 0, 5 ] }
              ]
            },
            {
              type: 'none',
              style: 'small',
              ul: [
                { text: 'Group', bold: true },
                { text: state.surveyDetails.group, margin: [ 0, 0, 0, 5 ] },
                { text: 'Building', bold: true },
                { text: state.surveyDetails.building, margin: [ 0, 0, 0, 5 ] }
              ]
            },
            {
              type: 'none',
              style: 'small',
              ul: [
                { text: 'Audit Type', bold: true },
                { text: state.surveyDetails.auditTypeName, margin: [ 0, 0, 0, 5 ] },
                { text: 'Auditor', bold: true },
                { text: state.surveyDetails.auditor, margin: [ 0, 0, 0, 5 ] },
                { text: 'Completed Date', bold: true },
                { text: state.surveyDetails.completedDate, margin: [ 0, 0, 0, 5 ] }
              ]
            }
          ]
        }
      ]
    }
    // Add logo if exists
    if (typeof localStorage.locationLogo !== 'undefined') {
      topSurveyDetails.columns.unshift({
        image: localStorage.locationLogo,
        fit: [150, 150]
      })
    } else {
      topSurveyDetails.columns.unshift({ text: state.surveyDetails.location })
    }
    content.push(topSurveyDetails)
    // Horizontal line (resource: https://goo.gl/eCPJRU)
    // content.push({
    //   canvas: [ { type: 'line', x1: 0, y1: 5, x2: 595 - 2 * 40, y2: 5, lineWidth: 1, lineColor: '#ccc' } ],
    //   margin: [ 0, 5, 0, 10 ]
    // })
    var buildingNotes = {
      columns: [
        {
          columns: [
            {
              type: 'none',
              style: 'small',
              ul: [
                { text: 'Building Notes', bold: true },
                { text: state.surveyDetails.buildingNotes, margin: [ 0, 5, 0, 5 ] }
              ]
            }
          ]
        }
      ]
    }
    content.push(buildingNotes)
    // Get all filenames separately with the questionId
    var photos = []
    state.survey.forEach((item) => {
      if (item.answer.photos.length > 0) {
        item.answer.photos.forEach((filename) => {
          photos.push({ questionId: item.question.id, filename: filename })
        })
      }
    })
    // Prepare a promises array to get photos first
    var promises = []
    if (photos.length > 0) {
      for (let i = 0; i < photos.length; i++) {
      // photos.forEach((item) => {
      // Fill promises array
        promises.push(
          new Promise((resolve, reject) => {
            window.app.$http
              .get(`/uploads/${state.surveyDetails.id}/${photos[i].questionId}/resized_${photos[i].filename}`, {
                responseType: 'arraybuffer'}).catch((error) => {
                console.debug(error)
                resolve({
                  questionId: 0,
                  dataURL: ``
                })
              })
              .then((response) => {
                let image = btoa(
                  new Uint8Array(response.data).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    ''
                  )
                )
                resolve({
                  questionId: photos[i].questionId,
                  dataURL: `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
                })
              })
              // .catch((error) => {
              //   console.debug(error)
              // For testing:
              // resolve({
              //   questionId: item.questionId,
              //   dataURL: localStorage.locationLogo
              // })
          })
          // })
        )
      }
    }
    // Horizontal line (resource: https://goo.gl/eCPJRU)
    content.push({
      canvas: [ { type: 'line', x1: 0, y1: 5, x2: 595 - 2 * 40, y2: 5, lineWidth: 1, lineColor: '#ccc' } ],
      margin: [ 0, 5, 0, 10 ]
    })

    Promise.all(promises).then((dataURLs) => {
    // Get unique sections
      var sections = [ ...new Set(state.survey.map((x) => x.section.id)) ]
      /**
       * Loop thru SECTIONS
       */
      sections.forEach((sectionId) => {
      // Section Title
        var title = state.survey.filter((y) => y.section.id === sectionId)[0].section.text
        var sectionPoints = 0
        var sectionPointsEarned = 0
        state.survey.filter((y) => y.section.id === sectionId).forEach((x) => {
          sectionPoints += x.question.points
          if (x.answer.id === 1) {
            sectionPointsEarned += x.question.points
          }
        })
        var sectionHeader = {
          table: {
            widths: [ '*', 110, 110 ],
            body: [
              [
                {
                  stack: [
                    { text: 'Survey Results for', style: 'small' },
                    { text: title, style: 'orangeTitleLarge' }
                  ]
                },
                {
                  stack: [
                    { text: 'Sections Points Earned', alignment: 'center', style: 'small' },
                    {
                      text: `${sectionPointsEarned}/${sectionPoints}`,
                      alignment: 'center',
                      style: 'orangeTitleLarge'
                    }
                  ]
                },
                {
                  stack: [
                    { text: 'Section Score', alignment: 'center', style: 'small' },
                    {
                      text: Math.round(sectionPointsEarned / sectionPoints * 100) + '%',
                      alignment: 'center',
                      style: 'orangeTitleLarge'
                    }
                  ]
                }
              ]
            ]
          },
          layout: 'noBorders'
        }
        sectionHeader.pageBreak = sectionId !== 1 ? 'before' : null
        content.push(sectionHeader)
        // Horizontal line (resource: https://goo.gl/eCPJRU)
        content.push({
          canvas: [ { type: 'line', x1: 0, y1: 5, x2: 595 - 2 * 40, y2: 5, lineWidth: 1, lineColor: '#ccc' } ],
          margin: [ 0, 5, 0, 20 ]
        })

        /**
        * Loop thru QUESTIONS
        */
        state.survey.filter((item) => item.section.id === sectionId).forEach((question) => {
          content.push({ text: question.question.text, bold: true })
          var questionPointsEarned = question.answer.id === 1 ? question.question.points : 0
          content.push({ text: 'Points earned: ' + questionPointsEarned, style: [ 'small', 'orange' ] })

          // Add comments
          if (question.answer.comments) {
            content.push({
              text: 'COMMENTS: ' + question.answer.comments,
              style: 'small'
            })
          }

          // Add photos
          if (dataURLs.length > 0) {
            var images = dataURLs.filter((x) => x.questionId === question.question.id)
            if (images.length > 0) {
              var _columns = []
              var columns = []
              var margin = [ 0, 10, 0, 0 ]
              var columnGap = 10
              images.forEach((image, i) => {
              // Add photo into columns array
                columns.push({
                  image: image.dataURL,
                  width: 252.5
                })
                // Whenever we got 2 columns(photos), we add them into the content
                if (columns.length === 2) {
                  _columns.push({ columns, margin, columnGap })
                  columns = []
                // If it's the last image, add the single column
                } else if (images.length === i + 1) {
                  _columns.push({ columns, margin, columnGap })
                }
              })
              content.push(_columns)
            }
          }

          // Divider
          content.push({
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 5,
                x2: 595 - 2 * 40,
                y2: 5,
                lineWidth: 1,
                lineColor: '#ccc'
              }
            ],
            margin: [ 0, 10 ]
          })
        })
      })
      // Create and Download PDF
      var docDefinition = {
        styles,
        content,
        footer
      }
      pdfMake
        .createPdf(docDefinition)
        .download(
          `${state.surveyDetails.building} - ${state.surveyDetails.location} - ${state.surveyDetails.auditor}.pdf`,
          function () { endLoading(dispatch, loaderName) }
        )
    })
  }, 0)
}



// WEBPACK FOOTER //
// ./src/store/modules/survey/complex/downloadReport.js